module.exports = __webpack_public_path__ + "img/tv.6ca32622.svg";